import React from 'react';

// Create a context with no initial values.
export const CartContext = React.createContext();

export default CartContext;
